import './shared/styles.css';
import 'ol/ol.css';
import 'ol-ext/dist/ol-ext.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './ctrls-over.css';

import Map from 'ol/Map';
import View from 'ol/View';
import {fromLonLat} from 'ol/proj';
import {Attribution, defaults as defaultControls} from 'ol/control';
import sync from 'ol-hashed';


import {createBasemapLayer, createDebugLayer, createHillshade, createColormapLayer, createContoursLayer} from './shared/layers.js';
import {setupLayerVisibility, setupCommonControls} from './shared/controls.js';
import {loadPlaceOnMap} from './shared/places.js';
import {createNav, syncMapToUrl, restoreMapFromUrl, setupNavSearch, setupNavPlaces, setupNavLayers} from './shared/nav.js';

import * as places from './main_places.json';

const basemapLayer = createBasemapLayer();
const debugLayer = createDebugLayer();
const {layer: hillshadeLayer} = createHillshade({transp: true});
const {layer: colormapLayer} = createColormapLayer();
const contours = createContoursLayer(100);
const contoursLayer = contours.layer;

const view = new View({ zoom: 14 });

const attribution = new Attribution({ collapsible: false });

const map = new Map({
    target: 'map',
    layers: [
        basemapLayer,
        colormapLayer,
        hillshadeLayer,
        contoursLayer,
        debugLayer,
    ],
    controls: defaultControls({attribution: false}).extend([attribution]),
    view: view,
});

// Nav bar
createNav();
if (!restoreMapFromUrl(view)) {
    if (places.features.length > 0) {
        const [lon, lat] = places.features[0].geometry.coordinates;
        view.setCenter(fromLonLat([lon, lat]));
    }
}
syncMapToUrl(map);

// Places dropdown in nav
setupNavPlaces(places.features, function (feat) {
    loadPlaceOnMap(feat, view);
});

// Layers dropdown in nav
var layerCbs = setupNavLayers([
    {id: 'cb-basemap', label: 'Basemap', checked: true},
    {id: 'cb-colormap', label: 'Colormap', checked: true},
    {id: 'cb-hillshade', label: 'Hillshade', checked: true},
    {id: 'cb-contours', label: 'Contours', checked: false},
    {id: 'cb-debug', label: 'Debug', checked: false},
]);
setupLayerVisibility(layerCbs, {
    'cb-basemap': basemapLayer,
    'cb-colormap': colormapLayer,
    'cb-hillshade': hillshadeLayer,
    'cb-contours': contoursLayer,
    'cb-debug': debugLayer,
});

// Popup & controls
setupCommonControls(map, contoursLayer);

sync(map);

// Geocoder search
setupNavSearch(function (loc) {
    var feat = {
        type: "Feature",
        geometry: {type: "Point", coordinates: [loc.lon, loc.lat]},
        properties: {name: loc.formatted},
    };
    loadPlaceOnMap(feat, view);
});
